<template>
  <div class="col-md-8 pd-5">
    <div class="card p-1 mb-0">
      <div class="d-flex justify-content-between align-items-center">
        <span>{{ statisticsItem[itemKey].name }}</span>
      </div>

      <div class="btn-group d-flex flex-wrap gap-1 p-1">
        <button
          v-for="type in tabs"
          :key="type"
          class="btn btn-sm flex-grow-1"
          :class="activeTab === type ? 'btn-primary' : 'btn-outline-primary'"
          @click="changeType(type)"
        >
          {{ type.toUpperCase() }}
        </button>
      </div>

      <HosSummaryTable
        :summary="statisticsItem[itemKey].data"
      />
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import HosSummaryTable from "@/components/molecule/company/dashboard/dynamic-dashboard/hospital-table/HosSummaryTable";

const emit = defineEmits(['onTypeChange']);

defineProps({
  statisticsItem: Object,
  itemKey: String,
  page: Object,
});

const changeType = (type) => {
  activeTab.value = type
  emit('onTypeChange', type)
}

const tabs = ['billing', 'investigation', 'incentive', 'accounts'];

const activeTab = ref("billing");
</script>
